import React from 'react';
import classNames from 'classnames';
import { testId } from '@jwp/ott-common/src/utils/common';

import Modal from '../Modal/Modal';
import Slide from '../Animation/Slide/Slide';
import ModalCloseButton from '../ModalCloseButton/ModalCloseButton';

import styles from './Dialog.module.scss';

type Props = {
  open: boolean;
  onClose?: () => void;
  HideBtn?: boolean;
  size?: 'small' | 'medium' | 'large';
  children: React.ReactNode;
  role: React.AriaRole;
  disabledBtn: boolean;
} & React.AriaAttributes;

const Dialog: React.FC<Props> = ({ open, onClose, HideBtn, children, size = 'small', role, disabledBtn, ...ariaAttributes }: Props) => {
  return (
    <Modal open={open} onClose={onClose} AnimationComponent={Slide} disabledBtn={disabledBtn} role={role} centered>
      <div className={classNames(styles.dialog, styles[size])} aria-modal="true" aria-label="Dialog" data-testid={testId('dialog')} {...ariaAttributes}>
        {children}
        { !HideBtn ? <ModalCloseButton onClick={onClose} /> : null}
      </div>
    </Modal>
  );
};

export default Dialog;
